module.exports = __webpack_public_path__ + "static/media/page-flip.33fb8bf7.mp3";